import React from 'react';
import AdminPart from './AdminPart/AdminPart';

const Admin = () => {
    return (
        <div>
            <AdminPart></AdminPart>
        </div>
    );
};

export default Admin;